import React from 'react';
import { WBFlex, WBIcon } from '@admiin-com/ds-web';
import { useTranslation } from 'react-i18next';
import { InputAdornment, OutlinedInput } from '@mui/material';

interface SearchClientInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  fullWidth?: boolean;
  inputRef?: React.Ref<HTMLInputElement>;
}

export const SearchClientInput: React.FC<SearchClientInputProps> = ({
  value,
  onChange,
  placeholder,
  fullWidth,
  inputRef,
}) => {
  const { t } = useTranslation();

  return (
    <WBFlex
      sx={fullWidth ? { width: '100%' } : { minWidth: ['100%', '500px'] }}
    >
      <SearchInput
        value={value}
        onChange={onChange}
        fullWidth
        placeholder={placeholder ?? t('searchClient', { ns: 'clients' })}
        inputRef={inputRef}
      />
    </WBFlex>
  );
};

export const SearchInput = ({
  value,
  onChange,
  placeholder,
  fullWidth = true,
  inputRef,
}: SearchClientInputProps) => {
  return (
    <OutlinedInput
      fullWidth={fullWidth}
      inputRef={inputRef}
      startAdornment={
        <InputAdornment position="start">
          <WBIcon name="Search" size="small" />
        </InputAdornment>
      }
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};
